import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Aturno - Gestión de Turnos",
  description = "Plataforma líder en gestión de turnos para empresas. Simplifica la reserva de citas, reduce las cancelaciones y mejora la experiencia de tus clientes.",
  keywords = "turnos, citas, reservas, gestión, negocio, agenda, booking, appointments",
  image = "/logo-aturno.png",
  url = "https://aturno.app",
  type = "website",
  author = "Aturno",
  canonical,
  noindex = false,
  nofollow = false,
  schema,
  children
}) => {
  const fullTitle = title.includes('Aturno') ? title : `${title} | Aturno`;
  const fullUrl = url.startsWith('http') ? url : `https://aturno.app${url}`;
  const fullImage = image.startsWith('http') ? image : `https://aturno.app${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Robots */}
      <meta name="robots" content={`${noindex ? 'noindex' : 'index'}, ${nofollow ? 'nofollow' : 'follow'}`} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Aturno" />
      <meta property="og:locale" content="es_AR" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:site" content="@aturno_app" />
      <meta name="twitter:creator" content="@aturno_app" />
      
      {/* Additional SEO Tags */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="geo.region" content="AR" />
      <meta name="geo.country" content="Argentina" />
      
      {/* Schema.org Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
      
      {children}
    </Helmet>
  );
};

export default SEO;